import React from "react";
import "./Ads.scss";

const Ads = () => {
  return (
    <div className="ads-placeholder">
      <h3>Cvanto Ads</h3>
      <p>Тут з’явиться конструктор рекламних кампаній, аудиторії та розширена статистика.</p>
      <ul>
        <li>Цілі кампаній: перегляди / кліки / повідомлення</li>
        <li>Гео, інтереси, частота показів</li>
        <li>Аналітика: CTR, CPM, CPC, конверсії</li>
      </ul>
      <div className="note">На цьому етапі ми не чіпаємо Cvanto Ads — лише підняття.</div>
    </div>
  );
};

export default Ads;
